import i18next from 'i18next';
import { MEDIA_TYPE, VIDEO_TYPE } from '../../../react/features/base/media/constants';
import { getLocalParticipant, getParticipantById, getParticipantCount, getRaiseHandsQueue, getVirtualScreenshareParticipantOwnerId, isScreenShareParticipant, isScreenShareParticipantById } from '../../../react/features/base/participants/functions';
import { getTrackByMediaTypeAndParticipant, getVideoTrackByParticipant, getVirtualScreenshareParticipantTrack, isLocalTrackMuted, isRemoteTrackMuted } from '../../../react/features/base/tracks/functions.any';
import { isTrackStreamingStatusInactive } from '../../../react/features/connection-indicator/functions';
import { setPipStreamToMainVideoElement } from './actions';
import { DEFAULT_INITIALS_FOR_CANVAS, STATUSES } from './constants';
const maxHandsShow = 3;
export function formatRaisedHands(state) {
    const raisedHandsQueue = getRaiseHandsQueue(state);
    const listForRender = [];
    for (let i = 0; i < raisedHandsQueue.length; i++) {
        const { id } = raisedHandsQueue[i];
        const participant = getParticipantById(state, id);
        if (i >= maxHandsShow) {
            listForRender.push({
                name: `+ more ${raisedHandsQueue.length - i}`
            });
            break;
        }
        else if (participant) {
            listForRender.push({
                id,
                name: participant.name ?? ''
            });
        }
    }
    return listForRender;
}
export function isVideoReady(videoEl) {
    return videoEl && videoEl.readyState >= 1 && videoEl.videoWidth > 0;
}
export const isMainVideoMuted = (state, participantId, tracks) => {
    if (isScreenShareParticipantById(state, participantId)) {
        return false;
    }
    return isRemoteTrackMuted(tracks, MEDIA_TYPE.VIDEO, participantId || '');
};
/* eslint-disable arrow-body-style*/
export const getSelectedParticipantId = (state, participantId) => {
    return isScreenShareParticipantById(state, participantId)
        ? getVirtualScreenshareParticipantOwnerId(participantId) : participantId;
};
export function isTileViewEnabled(state) {
    const participantCount = getParticipantCount(state);
    const { tileViewEnabled, remoteScreenShares } = state['features/video-layout'] ?? {};
    return tileViewEnabled
        ?? (tileViewEnabled === undefined && participantCount > 2 && remoteScreenShares.length <= 0);
}
function getBaseNameVariables(width, height) {
    return {
        fontSize: 30,
        fontSizeBig: 70,
        width,
        height,
        colorYellow: '#f2c94c',
        colorBlue: '#17aeff',
        colorDarkBlue: 'rgb(43, 51, 59)',
        colorWhite: '#fff',
        colorGray: 'rgb(150, 156, 162)',
        canvasBgColor: '#292929',
        colorBlackOpacity: 'rgba(0, 0, 0, 0.7)',
        get nameBgHeight() {
            return this.fontSize * 2;
        },
        tileModeTitle: i18next.t('PiP.tileModeTitle'),
        tileModeText: i18next.t('PiP.tileModeText'),
        titleLocalSharing: i18next.t('PiP.titleLocalSharing'),
        get tileModeTextWords() {
            return this.tileModeText.split(' ');
        },
        get bottomPositionBg() {
            return height - this.nameBgHeight - 10;
        },
        canvasMargin: 10,
        get marginNameWithMuteIcon() {
            return this.canvasMargin + 60;
        },
        get marginNameWithoutMuteIcon() {
            return this.canvasMargin + 20;
        },
        get topPositionForMuteIcon() {
            return this.bottomPositionBg + this.canvasMargin;
        },
        get topPositionForUserName() {
            return this.bottomPositionBg + 30;
        },
        get marginMuteIcon() {
            return this.canvasMargin + 10;
        },
        indent15: 15,
        indent20: 20,
        indent60: 60,
        indent70: 70,
        indent5: 5,
        baseSizeSmall: 40,
        baseSizeMedium: 80,
        getBackgroundNameWidth(isAudioStopped, textWidth) {
            return isAudioStopped ? textWidth + this.baseSizeMedium : textWidth + this.baseSizeSmall;
        },
        getSpaceForNameWithMuteIcon(isAudioStopped) {
            return isAudioStopped ? this.marginNameWithMuteIcon : this.marginNameWithoutMuteIcon;
        },
        centerXCanvas: width / 2,
        centerYCanvas: height / 2,
        textAlightLeft: 'left',
        textAlightCenter: 'center',
        circleRadius: 100,
        circleRadiusSmall: 70,
        borderRadius: 8,
        // eslint-disable-next-line max-len
        pathWithLine: new Path2D('M12 4.336c-1.438 0-2.39 1.062-2.422 2.562v.516l4.797 4.797a1.37 1.37 0 0 0 .04-.313V6.961c0-1.54-.97-2.625-2.415-2.625Zm5.414 13.469a.486.486 0 0 0 .695 0 .49.49 0 0 0 0-.688L6.836 5.852a.493.493 0 0 0-.695 0 .5.5 0 0 0 0 .695l11.273 11.258ZM6.836 12.063c0 2.828 1.875 4.828 4.68 5.03v1.9h-2.82a.475.475 0 0 0-.477.484c0 .265.21.476.476.476h6.602c.265 0 .476-.21.476-.476a.475.475 0 0 0-.476-.485h-2.82v-1.898c.882-.063 1.671-.297 2.328-.696l-.68-.695c-.594.32-1.313.508-2.125.508-2.555 0-4.203-1.688-4.203-4.18v-1.43a.477.477 0 0 0-.484-.484.475.475 0 0 0-.477.485v1.46Zm9.047 1.648.742.742c.344-.695.531-1.5.531-2.39v-1.461a.475.475 0 0 0-.476-.485.477.477 0 0 0-.485.485v1.43c0 .609-.11 1.179-.312 1.679ZM12 14.523c.29 0 .555-.046.79-.148l-3.212-3.21v.733c0 1.54.969 2.625 2.422 2.625Z'),
        // eslint-disable-next-line max-len
        pathHand: new Path2D('M6.88 14.683c0 2.966 2.058 4.75 4.758 4.75 1.88 0 3.158-.73 4.08-2.2.766-1.06 1.272-2.694 1.593-3.72.22-.697.513-1.578.561-1.961.055-.43-.198-.766-.615-.82-.472-.062-.8.205-1.06.751l-.916 2.003c-.075.178-.15.233-.246.233-.095 0-.178-.055-.178-.253V6.568a.793.793 0 0 0-.806-.813.797.797 0 0 0-.807.813v5.12a3.529 3.529 0 0 0-.499-.136V5.666a.791.791 0 0 0-.806-.807.791.791 0 0 0-.807.807v5.817c-.171.014-.349.035-.52.062V6.192a.795.795 0 0 0-.806-.806.795.795 0 0 0-.807.806v5.804c-.185.075-.349.171-.499.26v-4.04a.795.795 0 0 0-.807-.807.797.797 0 0 0-.813.807v6.467Z')
    };
}
export async function updateCanvas({ state, isUserAudioMuted = null, isUserVideoMuted = null, mainVideoState = null, isLocalScreenShare = null, videoTrackParams = null, tileViewEnabled }) {
    const { dimensions, canvasCtx, mainVideo, videoTrackStore, localVideoElement, listUsersRaisedHands, tileViewList } = state['wildix/features/PiP'];
    if (!canvasCtx) {
        return;
    }
    const isAudioOnly = state['features/base/audio-only'].enabled;
    const tileViewArray = Object.entries(tileViewList);
    const { participantId = '' } = state['features/large-video'];
    const participant = getParticipantById(state, participantId);
    const participantName = participant?.name ?? DEFAULT_INITIALS_FOR_CANVAS;
    const tracks = state['features/base/tracks'];
    const isSelectedUserAudioMuted = isRemoteTrackMuted(tracks, MEDIA_TYPE.AUDIO, getSelectedParticipantId(state, participantId));
    const isAudioStopped = isUserAudioMuted ?? isSelectedUserAudioMuted;
    const localVideoMuted = isAudioOnly || (isUserVideoMuted ?? isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO));
    const isMainVideoStopped = isAudioOnly || (mainVideoState ?? isMainVideoMuted(state, participantId, tracks));
    const isTileView = tileViewEnabled ?? isTileViewEnabled(state);
    const { conference } = state['features/base/conference'];
    const userID = conference?.myUserId();
    const mainVideoTrack = videoTrackParams ?? videoTrackStore;
    const localParticipantId = getLocalParticipant(state)?.id;
    const videoTrackByUser = getVideoTrackByParticipant(state, participant);
    const isLocalScreenshareOnLargeVideo = isLocalScreenShare ?? (participant?.id?.includes(localParticipantId ?? '')
        && videoTrackByUser?.videoType === VIDEO_TYPE.DESKTOP);
    const { width, height, localVideoWidth, localVideoHeight, localVideoX, localVideoY } = dimensions;
    const letterName = getFirstLetters(participantName);
    // @ts-ignore
    window.cancelAnimationFrame(APP.pipAnimationId);
    const nameVariables = getBaseNameVariables(width, height);
    const { fontSize, titleLocalSharing, centerXCanvas, centerYCanvas, textAlightCenter, textAlightLeft, pathWithLine, bottomPositionBg, canvasMargin, getSpaceForNameWithMuteIcon, marginMuteIcon, topPositionForMuteIcon, topPositionForUserName } = nameVariables;
    canvasCtx.clearRect(0, 0, width, height);
    console.warn('updateCanvas');
    if (isTileView) {
        console.warn('renderTileVideoMode');
        renderTileVideoMode({
            state,
            canvasCtx,
            nameVariables
        });
        step();
    }
    else if (isMainVideoStopped && !isScreenShareParticipantById(state, participantId) && localVideoMuted) {
        console.warn(isMainVideoStopped, 'isMainVideoStopped');
        renderCanvasName({
            canvasCtx,
            name: participantName,
            nameVariables,
            letterName,
            isAudioStopped
        });
    }
    else if (isLocalScreenshareOnLargeVideo) {
        console.warn('updateCanvas isLocalScreenShare');
        drawBgCanvas({ canvasCtx,
            nameVariables });
        drawCanvasText({ canvasCtx,
            fontSize,
            label: titleLocalSharing,
            positionLeft: centerXCanvas,
            positionTop: centerYCanvas,
            textAlight: textAlightCenter
        });
    }
    else {
        console.warn('updateCanvas animation frame');
        step();
    }
    setStreamToVirtualVideo(state);
    renderRaisedHands({
        canvasCtx,
        nameVariables,
        listUsersRaisedHands
    });
    function step() {
        if (isTileView) {
            for (let i = 0; i < tileViewArray.length; i++) {
                const [userId, currentUserObject] = tileViewArray[i];
                const { videoTrack, smallVideoElement, videoTrackID, isVideoPlaying, smallCanvas, smallCanvasCtx, smallWidth, smallHeight, coordinatesRender: { posX, posY } } = currentUserObject;
                if (!isVideoPlaying) {
                    continue;
                }
                if (userId === videoTrackID && !smallVideoElement.srcObject?.active) {
                    smallVideoElement.srcObject = videoTrack.stream;
                    console.warn('srcObject Injected');
                }
                drawCoverVideo(smallCanvasCtx, smallVideoElement, videoTrack, smallWidth, smallHeight, nameVariables);
                canvasCtx.drawImage(smallCanvas, posX, posY, smallWidth, smallHeight);
                drawSmallCanvasName(canvasCtx, tileViewList[userId], nameVariables);
            }
        }
        else if (!isMainVideoStopped && mainVideo) {
            drawCoverVideo(canvasCtx, mainVideo, mainVideoTrack, width, height, nameVariables);
            const textWidth = canvasCtx.measureText(participantName).width;
            // draw black bg for name
            drawBgForTitle({
                isAudioStopped,
                canvasCtx,
                textWidth,
                nameVariables,
                topPositionBg: bottomPositionBg,
                leftPositionBg: canvasMargin
            });
            // draw user-name
            drawCanvasText({ canvasCtx,
                fontSize,
                label: participantName,
                positionLeft: getSpaceForNameWithMuteIcon.call(nameVariables, isAudioStopped),
                positionTop: topPositionForUserName,
                textAlight: textAlightLeft
            });
            if (isAudioStopped) {
                drawIconByPath({
                    canvasCtx,
                    positionLeft: marginMuteIcon,
                    positionTop: topPositionForMuteIcon,
                    path: pathWithLine
                });
            }
        }
        else if (isMainVideoStopped) {
            canvasCtx.clearRect(0, 0, width, height);
            renderCanvasName({
                canvasCtx,
                name: participantName,
                nameVariables,
                letterName,
                isAudioStopped
            });
        }
        if (localVideoElement?.srcObject && !localVideoMuted) {
            if (participantId !== userID) {
                canvasCtx.drawImage(localVideoElement, localVideoX, localVideoY, localVideoWidth, localVideoHeight);
            }
            else {
                canvasCtx.drawImage(localVideoElement, 0, 0, width, height);
            }
        }
        renderRaisedHands({
            canvasCtx,
            nameVariables,
            listUsersRaisedHands
        });
        // @ts-ignore
        APP.pipAnimationId = requestAnimationFrame(step);
    }
}
// eslint-disable-next-line max-params
function drawCoverVideo(canvasCtx, smallVideoElement, videoTrack, width, height, nameVariables) {
    const { canvasBgColor } = nameVariables;
    const { aspectRatio = 1.7777 } = videoTrack?.track.getSettings() ?? {};
    const smallWidthCountScale = height * aspectRatio;
    const offsetXScale = -(smallWidthCountScale - width) / 2;
    canvasCtx.clearRect(0, 0, width, height);
    canvasCtx.fillStyle = canvasBgColor;
    canvasCtx.fillRect(0, 0, width, height);
    canvasCtx.drawImage(smallVideoElement, offsetXScale, 0, smallWidthCountScale, height);
}
function renderRaisedHands({ canvasCtx, nameVariables, listUsersRaisedHands }) {
    if (listUsersRaisedHands.length > 0) {
        const { fontSize, colorWhite, colorYellow, pathHand, canvasMargin, marginMuteIcon, baseSizeSmall, baseSizeMedium, textAlightLeft, indent15 } = nameVariables;
        canvasCtx.beginPath();
        canvasCtx.font = `${fontSize}px Open Sans`;
        canvasCtx.textAlign = textAlightLeft;
        canvasCtx.textBaseline = 'top';
        const BG_SIZE = 50;
        const currentXPos = 30;
        let currentYPos = 25;
        listUsersRaisedHands.forEach(({ name }) => {
            const widthText = canvasCtx.measureText(name).width;
            drawBgForTitle({
                isAudioStopped: false,
                canvasCtx,
                textWidth: widthText + BG_SIZE,
                nameVariables,
                topPositionBg: currentYPos - indent15,
                leftPositionBg: canvasMargin
            });
            drawIconByPath({
                canvasCtx,
                positionLeft: marginMuteIcon,
                positionTop: currentYPos - canvasMargin,
                scale: 1.8,
                path: pathHand,
                color: colorYellow
            });
            canvasCtx.fillStyle = colorWhite;
            canvasCtx.fillText(name, currentXPos + baseSizeSmall, currentYPos);
            currentYPos += baseSizeMedium;
        });
    }
}
function drawCanvasText({ canvasCtx, label, positionLeft, positionTop, fontSize, textAlight }) {
    canvasCtx.beginPath();
    canvasCtx.font = `${fontSize}px Open Sans`;
    canvasCtx.fillStyle = 'white';
    canvasCtx.textBaseline = 'middle';
    canvasCtx.textAlign = textAlight;
    // draw text tile view mode
    canvasCtx.fillText(label, positionLeft, positionTop);
}
export function getVideoAudioDataByUser(state, participantId) {
    const isAudioOnly = state['features/base/audio-only'].enabled;
    const tracks = state['features/base/tracks'];
    const audioTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.AUDIO, participantId);
    let videoTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, participantId);
    let isVideoPlaying = typeof videoTrack === 'undefined' ? false : !videoTrack?.muted;
    const isAudioStopped = typeof audioTrack === 'undefined' ? true : audioTrack?.muted;
    const participant = getParticipantById(state, participantId);
    const videoTrackID = participant?.id;
    if (isScreenShareParticipant(participant)) {
        videoTrack = getVirtualScreenshareParticipantTrack(tracks, participantId);
        isVideoPlaying = typeof videoTrack === 'undefined' ? false : !videoTrack?.muted;
    }
    isVideoPlaying = isAudioOnly === true ? false : isTrackStreamingStatusInactive(videoTrack) === true ? false : isVideoPlaying;
    return {
        videoTrack: videoTrack?.jitsiTrack,
        videoTrackID,
        isVideoPlaying,
        isAudioStopped
    };
}
export function getCustomListTileView(state, speakerId) {
    const { local, remote, dominantSpeaker } = state['features/base/participants'];
    const { dimensions, tileViewMaxUsers, tileViewList } = state['wildix/features/PiP'];
    const { width, height } = dimensions;
    const { canvasMargin } = getBaseNameVariables(width, height);
    const listVisibleUsers = {};
    let posX = canvasMargin;
    let posY = canvasMargin;
    const listRemoteUsers = [];
    let index = 0;
    if (remote.size === 0) {
        const localUserId = local?.id ?? '';
        const { videoTrack, isVideoPlaying, isAudioStopped, videoTrackID } = getVideoAudioDataByUser(state, localUserId);
        const participantCount = 1;
        const userNameCustom = local?.name;
        const { smallCanvas, smallCanvasCtx, smallVideoElement, smallWidth, smallHeight, userName, textWidth, coordinatesRender } = calculateSmallCanvas({
            dimensions,
            participantCount,
            state,
            index,
            name: userNameCustom,
            posX,
            posY
        });
        listVisibleUsers[local?.id] = {
            participant: local,
            smallCanvas,
            smallCanvasCtx,
            smallVideoElement,
            videoTrack,
            videoTrackID,
            isVideoPlaying,
            isAudioStopped,
            smallWidth,
            smallHeight,
            userName,
            textWidth,
            coordinatesRender
        };
        return listVisibleUsers;
    }
    // @ts-ignore
    for (const [id, participant] of remote.entries()) {
        // @ts-ignore
        if (id === dominantSpeaker && !tileViewList[speakerId]) {
            listRemoteUsers.unshift(participant);
        }
        else {
            listRemoteUsers.push(participant);
        }
    }
    console.warn(listRemoteUsers, remote, 'listRemoteUsers, remote');
    for (const participant of listRemoteUsers) {
        const { id, name } = participant;
        const { videoTrack, isVideoPlaying, isAudioStopped, videoTrackID } = getVideoAudioDataByUser(state, id);
        const isMaxUsers = index < tileViewMaxUsers;
        const participantCount = remote.size;
        const userNameCustom = isMaxUsers ? name : `+ more ${participantCount - index}`;
        const { smallCanvas, smallCanvasCtx, smallWidth, smallHeight, userName, textWidth, smallVideoElement, coordinatesRender } = calculateSmallCanvas({
            dimensions,
            participantCount,
            state,
            index,
            name: userNameCustom,
            posX,
            posY
        });
        posX = coordinatesRender.posX;
        posY = coordinatesRender.posY;
        if (isMaxUsers) {
            listVisibleUsers[id] = {
                participant,
                smallCanvas,
                smallCanvasCtx,
                smallVideoElement,
                videoTrack,
                videoTrackID,
                isVideoPlaying,
                isAudioStopped,
                smallWidth,
                smallHeight,
                userName,
                textWidth,
                coordinatesRender
            };
        }
        else {
            listVisibleUsers.staticUser = {
                staticUser: true,
                smallCanvas,
                smallCanvasCtx,
                smallWidth,
                smallHeight,
                userName,
                textWidth,
                coordinatesRender
            };
            break;
        }
        index++;
    }
    console.warn(listVisibleUsers, 'getCustomListTileView listVisibleUsers');
    return listVisibleUsers;
}
export function createTileViewCanvases(state) {
    const { tileViewMaxUsers } = state['wildix/features/PiP'];
    const resultArray = [];
    for (let i = 0; i <= tileViewMaxUsers; i++) {
        const canvas = document.createElement('canvas');
        const smallCanvasCtx = canvas.getContext('2d');
        const smallVideoElement = document.createElement('video');
        smallVideoElement.autoplay = true;
        resultArray.push({
            canvas,
            smallCanvasCtx,
            smallVideoElement
        });
    }
    return resultArray;
}
function calculateSmallCanvas({ dimensions, participantCount, state, index, name, posX, posY }) {
    const { tileCanvases } = state['wildix/features/PiP'];
    const { canvas, smallCanvasCtx, smallVideoElement } = tileCanvases[index];
    const { width, height } = dimensions;
    const { canvasMargin, fontSize, indent15 } = getBaseNameVariables(width, height);
    const baseMargin = canvasMargin * 2;
    const widthWithMargin = width - baseMargin;
    const heightWithMargin = height - baseMargin;
    let widthSmall = widthWithMargin;
    let heightSmall = heightWithMargin;
    console.warn('calculateSmallCanvas');
    if (participantCount === 1) {
        widthSmall = (width / participantCount) - baseMargin;
    }
    else if (participantCount / 3 <= 1) {
        widthSmall = (width / participantCount) - indent15;
    }
    else if (participantCount / 3 > 1) {
        widthSmall = (width / 3) - indent15;
        heightSmall = (height / 2) - indent15;
    }
    canvas.width = widthSmall;
    canvas.height = heightSmall;
    const { userName, textWidth } = truncateName(name, smallCanvasCtx, widthSmall, fontSize);
    const coordinatesRender = {
        posX,
        posY
    };
    if (posX + widthSmall + canvasMargin >= width - baseMargin && index !== 0) {
        coordinatesRender.posY += heightSmall + canvasMargin;
        coordinatesRender.posX = canvasMargin;
    }
    else if (index !== 0) {
        coordinatesRender.posX += widthSmall + canvasMargin;
    }
    smallVideoElement.srcObject = null;
    return {
        smallCanvas: canvas,
        smallCanvasCtx,
        smallVideoElement,
        smallWidth: widthSmall,
        smallHeight: heightSmall,
        userName,
        textWidth,
        coordinatesRender
    };
}
function truncateName(string, smallCanvasCtx, smallWidth, fontSize) {
    smallCanvasCtx.font = `${fontSize}px Open Sans`;
    const textWidth = smallCanvasCtx.measureText(string).width;
    if (textWidth + 100 > smallWidth) {
        const name = `${string.substring(0, 10)}...`;
        const textWidthNew = smallCanvasCtx.measureText(name).width;
        return {
            userName: name,
            textWidth: textWidthNew
        };
    }
    return {
        userName: string,
        textWidth
    };
}
function renderTileVideoMode({ state, canvasCtx, nameVariables }) {
    const { tileViewList } = state['wildix/features/PiP'];
    drawBgCanvas({ canvasCtx,
        nameVariables,
        color: nameVariables.colorDarkBlue
    });
    for (const [userId] of Object.entries(tileViewList)) {
        updateParticipantInSmallCanvas(userId, state);
    }
}
export function updateStaticUserCountName(state) {
    const { remote } = state['features/base/participants'];
    const { tileViewList, tileViewMaxUsers } = state['wildix/features/PiP'];
    const staticUser = tileViewList?.staticUser;
    staticUser.userName = `+ more ${remote.size - tileViewMaxUsers}`;
    updateParticipantInSmallCanvas('staticUser', state);
}
function drawDominantSpeaker(smallCanvasCtx, smallWidth, smallHeight, colorBlue) {
    smallCanvasCtx.lineWidth = 4;
    smallCanvasCtx.strokeStyle = colorBlue;
    smallCanvasCtx.strokeRect(0, 0, smallWidth, smallHeight);
    smallCanvasCtx.closePath();
}
export function updateParticipantInSmallCanvas(id, state) {
    const { tileViewList, canvasCtx, dimensions } = state['wildix/features/PiP'];
    const { width, height } = dimensions;
    const nameVariables = getBaseNameVariables(width, height);
    const { colorGray, textAlightCenter, fontSizeBig, canvasBgColor, indent5, circleRadiusSmall } = nameVariables;
    const { participant, smallCanvasCtx, isVideoPlaying, smallWidth, smallHeight, staticUser } = tileViewList[id];
    smallCanvasCtx.beginPath();
    if (!isVideoPlaying) {
        smallCanvasCtx.fillStyle = canvasBgColor;
        smallCanvasCtx.fillRect(0, 0, smallWidth, smallHeight);
    }
    smallCanvasCtx.beginPath();
    smallCanvasCtx.fill();
    if (!staticUser && !isVideoPlaying) {
        // draw circle for first letters
        smallCanvasCtx.beginPath();
        smallCanvasCtx.arc(smallWidth / 2, smallHeight / 2, circleRadiusSmall, 0, 2 * Math.PI, false);
        smallCanvasCtx.fillStyle = colorGray;
        smallCanvasCtx.fill();
        const letterName = getFirstLetters(participant?.name);
        // draw user first letters
        drawCanvasText({ canvasCtx: smallCanvasCtx,
            fontSize: fontSizeBig,
            label: letterName,
            positionLeft: smallWidth / 2,
            positionTop: (smallHeight / 2) + indent5,
            textAlight: textAlightCenter
        });
    }
    drawSmallCanvasName(canvasCtx, tileViewList[id], nameVariables);
}
function drawSmallCanvasName(canvasCtx, currentUser, nameVariables) {
    const { fontSize, textAlightLeft, getSpaceForNameWithMuteIcon, pathWithLine, colorBlue, canvasMargin, baseSizeSmall, indent20, indent60, indent70 } = nameVariables;
    const { participant, smallCanvasCtx, isAudioStopped, smallWidth, smallHeight, smallCanvas, staticUser, userName, textWidth, coordinatesRender } = currentUser;
    if (participant?.dominantSpeaker) {
        drawDominantSpeaker(smallCanvasCtx, smallWidth, smallHeight, colorBlue);
    }
    if (!staticUser) {
        // draw black bg for name
        drawBgForTitle({
            isAudioStopped,
            canvasCtx: smallCanvasCtx,
            textWidth,
            nameVariables,
            topPositionBg: smallHeight - indent70,
            leftPositionBg: canvasMargin
        });
    }
    const centerX = (smallWidth / 2) - (textWidth / 2);
    const centerY = smallHeight / 2;
    const postLeft = staticUser ? centerX
        : getSpaceForNameWithMuteIcon.call(nameVariables, isAudioStopped);
    const postTop = staticUser ? centerY : smallHeight - baseSizeSmall;
    // draw user-name
    drawCanvasText({ canvasCtx: smallCanvasCtx,
        fontSize,
        label: userName,
        positionLeft: postLeft,
        positionTop: postTop,
        textAlight: textAlightLeft
    });
    if (isAudioStopped && !staticUser) {
        drawIconByPath({
            canvasCtx: smallCanvasCtx,
            positionLeft: indent20,
            positionTop: smallHeight - indent60,
            path: pathWithLine
        });
    }
    if (canvasCtx) {
        canvasCtx.drawImage(smallCanvas, coordinatesRender.posX, coordinatesRender.posY, smallWidth, smallHeight);
    }
}
export function setStreamToVirtualVideo(state) {
    const { canvasEl, virtualVideoEl } = state['wildix/features/PiP'];
    if (virtualVideoEl) {
        virtualVideoEl.srcObject = canvasEl?.captureStream(25) || null;
    }
}
function renderCanvasName({ canvasCtx, name, nameVariables, letterName, isAudioStopped }) {
    const { fontSize, centerXCanvas, centerYCanvas, circleRadius, colorGray, bottomPositionBg, pathWithLine, textAlightCenter, textAlightLeft, canvasMargin, getSpaceForNameWithMuteIcon, marginMuteIcon, topPositionForMuteIcon, topPositionForUserName, fontSizeBig, indent5 } = nameVariables;
    canvasCtx.font = `${fontSize}px Open Sans`;
    const textWidth = canvasCtx.measureText(name).width;
    drawBgCanvas({ canvasCtx,
        nameVariables });
    // draw circle for first letters
    canvasCtx.beginPath();
    canvasCtx.arc(centerXCanvas, centerYCanvas, circleRadius, 0, 2 * Math.PI, false);
    canvasCtx.fillStyle = colorGray;
    canvasCtx.fill();
    canvasCtx.stroke();
    // draw user first letters
    drawCanvasText({ canvasCtx,
        fontSize: fontSizeBig,
        label: letterName,
        positionLeft: centerXCanvas,
        positionTop: centerYCanvas + indent5,
        textAlight: textAlightCenter
    });
    // draw black bg for name
    drawBgForTitle({
        isAudioStopped,
        canvasCtx,
        textWidth,
        nameVariables,
        topPositionBg: bottomPositionBg,
        leftPositionBg: canvasMargin
    });
    // draw user-name
    drawCanvasText({ canvasCtx,
        fontSize,
        label: name,
        positionLeft: getSpaceForNameWithMuteIcon.call(nameVariables, isAudioStopped),
        positionTop: topPositionForUserName,
        textAlight: textAlightLeft
    });
    if (isAudioStopped) {
        drawIconByPath({
            canvasCtx,
            positionLeft: marginMuteIcon,
            positionTop: topPositionForMuteIcon,
            path: pathWithLine
        });
    }
}
function drawBgForTitle({ canvasCtx, isAudioStopped, textWidth, nameVariables, topPositionBg, leftPositionBg }) {
    const { nameBgHeight, borderRadius, colorBlackOpacity, getBackgroundNameWidth } = nameVariables;
    const bgWidth = getBackgroundNameWidth.call(nameVariables, isAudioStopped, textWidth);
    canvasCtx.beginPath();
    canvasCtx.fillStyle = colorBlackOpacity;
    if (typeof canvasCtx.roundRect !== 'undefined') {
        canvasCtx?.roundRect(leftPositionBg, topPositionBg, bgWidth, nameBgHeight, borderRadius);
    }
    else {
        canvasCtx.fillRect(leftPositionBg, topPositionBg, bgWidth, nameBgHeight);
    }
    canvasCtx.fill();
    return canvasCtx;
}
function drawIconByPath({ canvasCtx, positionLeft, positionTop, path, scale = 1.6, color = 'white' }) {
    canvasCtx.fillStyle = color;
    const domMatrix = new DOMMatrix();
    const newPath2D = new Path2D();
    domMatrix.translateSelf(positionLeft, positionTop);
    domMatrix.scaleSelf(scale);
    newPath2D.addPath(path, domMatrix);
    canvasCtx.fill(newPath2D);
    return canvasCtx;
}
function drawBgCanvas({ canvasCtx, nameVariables, color }) {
    const { width, height, canvasBgColor } = nameVariables;
    // draw canvas background
    canvasCtx.beginPath();
    canvasCtx.fillStyle = color ?? canvasBgColor;
    canvasCtx.fillRect(0, 0, width, height);
    canvasCtx.stroke();
    canvasCtx.fill();
    return canvasCtx;
}
function getFirstLetters(str) {
    let firstLetters = DEFAULT_INITIALS_FOR_CANVAS;
    const matchArr = str.match(/\b(\w)/g);
    if (Array.isArray(matchArr)) {
        firstLetters = matchArr.join('');
    }
    return firstLetters.toUpperCase().substring(0, 2);
}
export function updateMainVideoStream(state, dispatch) {
    const { participantId } = state['features/large-video'];
    const participant = getParticipantById(state, participantId);
    const tracks = state['features/base/tracks'];
    let videoTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, participantId);
    if (isScreenShareParticipant(participant)) {
        videoTrack = getVirtualScreenshareParticipantTrack(tracks, participantId);
    }
    const jitsiTrack = videoTrack?.jitsiTrack;
    if (videoTrack && jitsiTrack) {
        dispatch(setPipStreamToMainVideoElement(jitsiTrack.stream, jitsiTrack));
        updateCanvas({
            state,
            videoTrackParams: jitsiTrack,
            mainVideoState: isTrackStreamingStatusInactive(videoTrack) || jitsiTrack?.isMuted()
        });
    }
    else {
        updateCanvas({
            state
        });
    }
}
export function isPipPlaying(state) {
    const { pipStatus } = state['wildix/features/PiP'];
    return pipStatus === STATUSES.PLAYING;
}
